import { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import { useAuthStore, useTenantStore } from '@/app/stores';
import { router } from '@/app/router';
import { ThemeApplier } from '@/features/tenant/ThemeApplier';

export default function App() {
  const loadTenant = useTenantStore((s) => s.load);
  const initAuth = useAuthStore((s) => s.init);

  useEffect(() => {
    void loadTenant();
    void initAuth();
  }, [loadTenant, initAuth]);

  return (
    <>
      <ThemeApplier />
      <RouterProvider router={router} future={{ v7_startTransition: true }} />
    </>
  );
}
